import script from "./AffiliateResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliateResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./AffiliateResetPassword.vue?vue&type=style&index=0&id=1b2aba77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2aba77"]])

export default __exports__